<template>
  <div class="wrap" id="wrap">
    <div class="logo_title">
      <!-- <img src="../assets/img/logo.png" alt=""> -->
      <i class="header-logo"></i>
      <div class="title">
        <span>资源库学习应用推广服务</span>
        <!-- <span>GuoKai Stone (Beijing) Software Technology Co.,Ltd</span> -->
      </div>
    </div>
    <img src="../assets/img/dataAnalysis.png" class="dataAnalysis">
    <!-- <div class="text_background">
      <img src="../assets/img/indexBg.png">
      <img src="../assets/img/textBg.png">
    </div> -->
    <img src="../assets/img/spherical.png" class="spherical">
    <div class="logGet">
      <div class="dataAnalysisText">DATA &nbsp; ANALYSIS</div>
      <div class="virtualization"></div>
      <img src="../assets/img/blueBoxTopLeft.svg" class="blueBoxTopLeft">
      <img src="../assets/img/blueBoxTopRight.svg" class="blueBoxTopRight">
      <img src="../assets/img/blueBoxBttomLeft.svg" class="blueBoxBttomLeft">
      <img src="../assets/img/blueBoxBttomRight.svg" class="blueBoxBttomRight">
      <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px">
        <div class="loginText">用户登录</div>
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入用户名称">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" placeholder="请输入登录密码" v-model="loginForm.password" show-password>
          </el-input>
        </el-form-item>
        <el-form-item prop="verifyCode">
          <el-row :span="24">
            <el-col :span="14">
              <!-- @keyup.enter.native="submitForm('loginForm')" -->
              <el-input v-model="loginForm.verifyCode" maxlength="4" onkeyup="this.value=this.value.replace(/\D/g,'')" auto-complete="off" placeholder="请输入验证码" style="width:89%;"></el-input>
            </el-col>
            <el-col :span="10">
              <div class="login-code">
                <div class="iconCode">
                  <img :src="imgCode" style="width:100%;height:100%;border-radius: 6px 0px 0px 6px;">
                </div>
                <div class="refresh" @click="refreshCode"><i :class="[rotate?'isrefresh':'el-icon-refresh']" class="el-icon-refresh"></i></div>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <div class="login-btn">
            <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 粒子波浪 -->
    <div ref="particleWaves" class="particleWav"></div>

    <!-- 弹幕 -->
    <div class="bulletChat">
      <div v-for="(item,index) in bulletChatTestLeft" :key="index" class="bulletChatStyleRight" :style="{animation:'bulletChatRight '+(item.speed+item.random)+'s'+' linear'+' infinite',top:item.top+'px',color:item.color}">
        {{item.name}}
      </div>
      <div v-for="(items,indexs) in bulletChatTestRight" :key="indexs+1.1" class="bulletChatStyleLeft" :style="{animation:'bulletChatLeft '+items.speed+'s'+' linear'+' infinite',top:items.top+'px',color:items.color}">
        {{items.name}}
      </div>
    </div>

    <!-- 底部公司名称和logo -->
    <div class="company">
      <img src="../assets/img/logo.png" alt="">
      <div>
        <span>国开视通（北京）软件技术有限公司</span>
        <span>GuoKai Stone (Beijing) Software Technology Co.,Ltd</span>
      </div>
    </div>
  </div>
</template>

<script>
import THREE from '../../public/three.min';

export default {
  data() {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    return {
      testList:[
        {
          "label": "默认",
          "id": -1,
          "children": [],
          "value": -1
        },
        {
          "label": "电信",
          "children": [
            {
              "label": "华东电信",
              "children": [
                {
                  "label": "安徽电信",
                  "id": 51,
                  "children": null,
                  "value": 51
                },
                {
                  "label": "福建电信",
                  "id": 52,
                  "children": null,
                  "value": 52
                },
                {
                  "label": "江苏电信",
                  "id": 53,
                  "children": null,
                  "value": 53
                }
              ],
              "id": 11,
              "value": 11
            },
            {
              "label": "华南电信",
              "children": [
                {
                  "label": "广东电信",
                  "id": 58,
                  "children": null,
                  "value": 58
                },
                {
                  "label": "广西电信",
                  "id": 59,
                  "children": null,
                  "value": 59
                }
              ],
              "id": 12,
              "value": 12
            }
          ],
          "id": 1,
          "value": 1
        },
        {
          "label": "联通",
          "children": [
            {
              "label": "华东联通",
              "children": [
                {
                  "label": "安徽联通",
                  "id": 91,
                  "children": null,
                  "value": 91
                },
                {
                  "label": "福建联通",
                  "id": 92,
                  "children": null,
                  "value": 92
                },
                {
                  "label": "江苏联通",
                  "id": 93,
                  "children": null,
                  "value": 93
                }
              ],
              "id": 21,
              "value": 21,
              "disabled": true
            },
            {
              "label": "华南联通",
              "children": [
                {
                  "label": "广东联通",
                  "id": 98,
                  "children": null,
                  "value": 98
                },
                {
                  "label": "广西联通",
                  "id": 99,
                  "children": null,
                  "value": 99
                },
                {
                  "label": "海南联通",
                  "id": 100,
                  "children": null,
                  "value": 100
                }
              ],
              "id": 22,
              "value": 22,
              "disabled": true
            }
          ],
          "id": 2,
          "value": 2,
          "disabled": true
        },
        {
          "label": "移动",
          "children": [
            {
              "label": "华东移动",
              "children": [
                {
                  "label": "安徽移动",
                  "id": 131,
                  "children": null,
                  "value": 131
                }
              ],
              "id": 31,
              "value": 31,
              "disabled": true
            },
            {
              "label": "华南移动",
              "children": [
                {
                  "label": "广东移动",
                  "id": 138,
                  "children": null,
                  "value": 138
                },
                {
                  "label": "广西移动",
                  "id": 139,
                  "children": null,
                  "value": 139
                },
                {
                  "label": "海南移动",
                  "id": 140,
                  "children": null,
                  "value": 140
                }
              ],
              "id": 32,
              "value": 32,
              "disabled": true
            }
          ],
          "id": 3,
          "value": 3,
          "disabled": true
        },
        {
          "label": "教育网",
          "id": 6,
          "children": null,
          "value": 6
        },
        {
          "label": "电信通",
          "id": 7,
          "children": null,
          "value": 7
        }
      ],
      selectedOptions:[],
      loginForm: {
        username: '',
        password: '',
        verifyCode: '',
        key: '',
      },
      rules: {
        username: [
          { validator: validateName, trigger: 'blur' },
        ],
        password: [
          { validator: validatePass, trigger: 'blur' },
        ],
        verifyCode: [
          { validator: validateCode, trigger: 'blur' },
        ],
      },
      rotate: false, // 点击验证码的刷新添加动画
      bulletChatList: ['人工智能', '自然语言处理技术', 'K-Means聚类算法', '专业词向量岗位', '词向量Word2vec大数据清洗', 'LDA主题分类', 'Doc2ver深度学习神经网络'], // 弹幕文字
      bulletChatTestLeft: [],
      bulletChatTestRight: [],
      imgCode: '',
    };
  },
  // 卸载
  beforeDestroy() {
    this.particleWave.renderer.clear();
    this.particleWave = { // 粒子波浪
      SEPARATION: 50,
      AMOUNTX: 600,
      AMOUNTY: 20,
      container: '',
      camera: '',
      scene: '',
      renderer: '',
      particles: '',
      particle: '',
      count: 0,
      mouseX: 0,
      mouseY: 0,
      windowHalfX: null,
      windowHalfY: null,
    };
    removeEventListener('resize', this.onWindowResize);
    window.removeEventListener('keydown', this.keyDown, false);// 销毁回车事件，如果不销毁，在其他页面敲回车也会执行回车登录操作。
  },
  created() {
    this.refreshCode();
    window.addEventListener('keydown', this.keyDown);// 监听用户回车事件
  },
  mounted() {
    this.particleWave = { // 粒子波浪
      SEPARATION: 50,
      AMOUNTX: 600,
      AMOUNTY: 20,
      container: '',
      camera: '',
      scene: '',
      renderer: '',
      particles: '',
      particle: '',
      count: 0,
      mouseX: 0,
      mouseY: 0,
      windowHalfX: null,
      windowHalfY: null,
    };
    this.particleWave.scene = new THREE.THREE.Scene();
    this.particleWave.windowHalfX = window.innerWidth / 2;
    this.particleWave.windowHalfY = window.innerHeight / 2;
    this.init();
    this.animate();
    // this.bulletChats('left')
    // this.bulletChats('right')
  },
  methods: {
    // 回车登录
    keyDown(e) {
      if (e.keyCode == 13) { // 13是回车键的keycode
        this.submitForm('loginForm');
      }
    },
    // 生成uuid
    guid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (`${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`);
    },
    // 获取刷新验证码
    refreshCode() {
      this.loginForm.key = this.guid();
      const that = this;
      this.$axios({
        method: 'get',
        url: `${that.$apiurls.validation_code}?key=${that.loginForm.key}`,
        responseType: 'blob',
      }).then((res) => {
        if (res) {
          that.imgCode = window.URL.createObjectURL(res);
          this.rotate = !this.rotate;
        }
      });
    },
    // 登录
    submitForm(formName) {
      const that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post(that.$apiurls.login, this.loginForm, {
            loading: false,
          }).then((res) => {
            if (res) {
              if (res.code == 200) {
                if (res.data.enabled == 1) {
                  sessionStorage.setItem('userName', res.data.userName);
                  sessionStorage.setItem('professional', res.data.professional);
                  sessionStorage.setItem('lrmv2token', res.data.token);
                  sessionStorage.setItem('userType', res.data.userType); // 1 超级管理员 2主持单位  3参建单位
                  sessionStorage.setItem('zykId', res.data.zykId);
                  sessionStorage.setItem('province', res.data.province);

                  if (sessionStorage.getItem('selectMenu') && sessionStorage.getItem('selectMenu').path) {
                    that.$router.replace(sessionStorage.getItem('selectMenu').path);
                  } else {
                    that.$router.replace('/essential');
                    console.log(123);
                  }

                  res.data.menuEntityList = res.data.menuEntityList.sort((a, b) => a.sort - b.sort);
                  sessionStorage.setItem('menu', this.$Utils.demoRequest(JSON.stringify(res.data.menuEntityList)));

                  this.$message({
                    message: '登录成功！',
                    type: 'success',
                  });
                } else {
                  that.$message.error('该账户暂未启用！');
                }
              } else if (res.code == 0) {
                that.refreshCode();
                that.$message.error(res.message);
              }
            }
          });
        } else {
          return false;
        }
      });
    },

    // 弹幕
    bulletChats(text) {
      const arrList = [];
      if (text == 'left') {
        this.bulletChatTestLeft = [];
      } else {
        this.bulletChatTestRight = [];
      }
      this.bulletChatList.forEach((v) => {
        const top = Math.floor(Math.random() * (380 - 20)) + 20;
        let speed = Math.floor(Math.random() * (20 - 10)) + 15;
        let random = Math.floor(Math.random() * (5 - 1)) + 1;
        if (random <= 5 && random >= 8) {
          random = parseInt(`-${random}`);
        }
        if (speed <= 3 && speed >= 1) {
          speed = 20;
        }
        arrList.push({
          top,
          speed,
          name: v,
          color: this.randomRgbColor(),
          random,
        });
      });
      if (text == 'left') {
        this.bulletChatTestLeft = arrList;
      } else {
        this.bulletChatTestRight = arrList;
      }
    },

    // 随机颜色
    randomRgbColor() { // 随机生成RGB颜色
      const r = Math.floor(Math.random() * 256); // 随机生成256以内r值
      const g = Math.floor(Math.random() * 256); // 随机生成256以内g值
      const b = Math.floor(Math.random() * 256); // 随机生成256以内b值
      return `rgb(${r},${g},${b})`; // 返回rgb(r,g,b)格式颜色
    },

    // 粒子波浪
    init() {
      this.particleWave.container = this.$refs.particleWaves;
      // document.body.appendChild(this.particleWave.container);
      this.particleWave.camera = new THREE.THREE.PerspectiveCamera(80, window.innerWidth / window.innerHeight, 1, 10000);
      this.particleWave.camera.position.z = 700;
      this.particleWave.camera.position.y = 300;
      this.particleWave.scene = new THREE.THREE.Scene();
      this.particleWave.particles = new Array();
      const PI2 = Math.PI * 2;
      const material = new THREE.THREE.ParticleCanvasMaterial({
        color: 0x4387d6,
        opacity: 0.5,
        program(context) {
          context.beginPath();
          context.arc(0, 0, 1, 0, PI2, true);
          context.fill();
        },
      });
      let i = 0;
      for (let ix = 0; ix < this.particleWave.AMOUNTX; ix++) {
        for (let iy = 0; iy < this.particleWave.AMOUNTY; iy++) {
          this.particleWave.particle = this.particleWave.particles[i++] = new THREE.THREE.Particle(material);
          this.particleWave.particle.position.x = ix * this.particleWave.SEPARATION - ((this.particleWave.AMOUNTX * this.particleWave.SEPARATION) / 2);
          this.particleWave.particle.position.z = iy * this.particleWave.SEPARATION - ((this.particleWave.AMOUNTY * this.particleWave.SEPARATION) / 2) + 400;
          this.particleWave.scene.add(this.particleWave.particle);
        }
      }
      this.particleWave.renderer = new THREE.THREE.CanvasRenderer();
      this.particleWave.renderer.setSize(window.innerWidth, window.innerHeight);
      this.particleWave.container.appendChild(this.particleWave.renderer.domElement);
      window.addEventListener('resize', this.onWindowResize, false);
    },

    onWindowResize() {
      this.particleWave.windowHalfX = window.innerWidth / 2;
      this.particleWave.windowHalfY = window.innerHeight / 2;
      this.particleWave.camera.aspect = window.innerWidth / window.innerHeight;
      this.particleWave.camera.updateProjectionMatrix();
      this.particleWave.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animate() {
      requestAnimationFrame(this.animate);
      this.render();
    },
    render() {
      if (this.particleWave.camera) {
        this.particleWave.camera.lookAt(this.particleWave.scene.position);
        let i = 0;
        for (let ix = 0; ix < this.particleWave.AMOUNTX; ix++) {
          for (let iy = 0; iy < this.particleWave.AMOUNTY; iy++) {
            this.particleWave.particle = this.particleWave.particles[i++];
            this.particleWave.particle.position.y = (Math.sin((ix + this.particleWave.count) * 0.3) * 50) + (Math.sin((iy + this.particleWave.count) * 0.5) * 50); // 调节抖动幅度
            this.particleWave.particle.scale.x = this.particleWave.particle.scale.y = (Math.sin((ix + this.particleWave.count) * 0.3) + 1) + (Math.sin((iy + this.particleWave.count) * 0.5) + 1) * 0.3; // 调节粒子大小
          }
        }
        this.particleWave.renderer.render(this.particleWave.scene, this.particleWave.camera);
        this.particleWave.count += 0.05; // 调节粒子速度
      }
    },
  },
};
</script>

<style>
body {
  height: 100vh;
  /* background: url("../assets/img/loginbg.png") 0px 0px no-repeat; */
  /* background-size: 100% 100%; */
  background: #091029;
}

#wrap {
  height: 100vh;
  width: 100%;
  background-position: center center;
  position: relative;
  overflow: hidden;
}

/* logo+标题 */
.logo_title {
  color: #4387d6;
  display: flex;
  align-items: center;
  position: absolute;
  top: 5%;
  left: 5%;
}

.header-logo {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.logo_title .title {
  display: flex;
  flex-flow: column;
}

.logo_title .title span:first-child {
  font-weight: 700;
  font-size: 30px;
}

.dataAnalysis {
  width: 45%;
  position: absolute;
  top: 29%;
  left: 5%;
}

.text_background {
  width: 30%;
  position: absolute;
  bottom: 10%;
  left: 5%;
  display: flex;
  flex-flow: column;
  z-index: 3;
}

.text_background img:first-child {
  width: 25%;
  margin-bottom: 5%;
}

.dataAnalysisText {
  position: absolute;
  top: -18%;
  left: 5%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  font-weight: 700;
  color: #26a1ff;
  opacity: 0.5;
  letter-spacing: 3px;
}

/* 背景地球 */
.spherical {
  width: 38%;
  position: absolute;
  top: 3%;
  right: 6%;
  animation: turn 30s linear infinite;
}

/* 旋转动画 */
@keyframes turn {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(270deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

#wrap .logGet {
  width: 300px;
  position: absolute;
  top: 50%;
  left: 70%;
  transform: translate(-50%, -50%);
  padding: 30px;
  border-radius: 8px;
  background: rgba(17, 26, 52, 0.8);
  z-index: 3;
}

/* 四个边角图标 */
.blueBoxTopLeft {
  position: absolute;
  top: 0%;
  left: 0%;
}
.blueBoxTopRight {
  position: absolute;
  top: 0%;
  right: 0%;
}
.blueBoxBttomLeft {
  position: absolute;
  bottom: 0%;
  left: 0%;
}
.blueBoxBttomRight {
  position: absolute;
  bottom: 0%;
  right: 0%;
}

/* 模糊 */
.virtualization {
  background: rgba(17, 26, 52, 0.01);
  filter: blur(3px);
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
}

.loginText {
  font-size: 24px;
  font-weight: bold;
  color: #26a1ff;
  letter-spacing: 5px;
  margin-bottom: 20px;
}

/* 验证码 */
.login-code {
  display: flex;
  justify-content: flex-end;
}

.iconCode {
  width: 90px;
  height: 40px;
}

.refresh {
  width: 50px;
  height: 40px;
  background: rgba(145, 145, 175, 0.39);
  border-radius: 0px 6px 6px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-icon-refresh {
  font-size: 24px;
  color: #fff;
  transition: all 2s;
}

.isrefresh {
  transform: rotate(180deg);
  transition: all 2s;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
}

.login-btn .el-button {
  width: 100%;
  background: url("../assets/img/loginButton.svg") 0px 0px no-repeat;
  background-size: 100% 100%;
  border: 0px;
  color: transparent;
  box-shadow: 5px 5px 8px rgba(145, 145, 175, 0.39);
}

/* 粒子波浪 */
.particleWav {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0%;
  left: 0%;
  /* z-index: -1; */
}

/* 弹幕 */
.bulletChat {
  width: 100%;
  height: 400px;
  position: absolute;
  bottom: 0%;
  left: 0%;
  z-index: 2;
}

/* 左边弹幕 */
.bulletChatStyleLeft {
  text-align: left;
  position: absolute;
  white-space: nowrap;
  opacity: 0.5;
  /* filter: blur(1px); */
}

/* 右边弹幕 */
.bulletChatStyleRight {
  text-align: right;
  position: absolute;
  white-space: nowrap;
  opacity: 0.5;
  /* filter: blur(1px); */
}

@keyframes bulletChatRight {
  0% {
    left: 100%;
  }
  30% {
    left: 70%;
  }
  50% {
    left: 50%;
  }
  70% {
    left: 30%;
  }
  100% {
    left: 0%;
  }
}

@keyframes bulletChatLeft {
  0% {
    left: 0%;
  }
  30% {
    left: 30%;
  }
  50% {
    left: 50%;
  }
  70% {
    left: 70%;
  }
  100% {
    left: 100%;
  }
}

/* 底部的公司和logo */
.company {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  color: #3a76c3;
  font-size: 15px;
}
.company div span:first-child {
  margin-right: 10px;
}

.company img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
</style>
